
import {
  Component, Mixins,
} from 'vue-property-decorator';
import TaskEditDialog from '@/components/TaskEditDialog.vue';
import DialogMixin from '@/mixins/DialogMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import TaskMixin from '@/mixins/TaskMixin.vue';
import { getLeadCustomValueText } from '@/helpers';

@Component({
  components: {
    TaskEditDialog,
  },
})
export default class EditLeadIbanDialog extends Mixins(DialogMixin, UtilsMixin, TaskMixin) {
  iban: string | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.iban = getLeadCustomValueText(this.selectedLead, 'iban') ?? null;

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  get ibanRequiredRules() { return this.ibanRules(this.iban); }
}
